module.exports = __webpack_public_path__ + "static/img/test-img-mb.5ccb152.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/_temp/test-img-mb.jpg
// module id = QFKD
// module chunks = 0